module.exports = "<div class=\"row\">\r\n  <div class=\"col-sm-12\">\r\n    <span><i class=\"fa fa-error\"></i><b>Invalid Configuration Key</b></span>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"col-sm-12\">\r\n        Please try your request again or contact us for further assistance.\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/app/invalid-configurationkey/invalid-configurationkey.component.html
// module id = ../../../../../src/app/invalid-configurationkey/invalid-configurationkey.component.html
// module chunks = main